import React from "react";
import { Select } from "antd";

const { Option } = Select;
const ALL = "__select_all__";

// A multiple Select with a "Select all" option at the top: choosing it selects
// every option, or clears them all when everything is already selected.
// Works inside a Form.Item (value / onChange come from the form).
export default function SelectAllMultiple({ options, value, onChange, ...rest }) {
  const selected = Array.isArray(value) ? value : [];
  const allValues = options.map((o) => o.value);
  const allSelected = allValues.length > 0 && allValues.every((v) => selected.includes(v));

  const handleChange = (next) => {
    if (next.includes(ALL)) {
      onChange && onChange(allSelected ? [] : allValues);
      return;
    }
    onChange && onChange(next);
  };

  return (
    <Select mode="multiple" showSearch optionFilterProp="children" value={selected} onChange={handleChange} {...rest}>
      {options.length > 0 && <Option key={ALL} value={ALL}>{allSelected ? "Clear all" : "Select all"}</Option>}
      {options.map((o) => <Option key={o.value} value={o.value}>{o.label}</Option>)}
    </Select>
  );
}
